module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows-a9b74121e9acf49028f1b70a0b662185.png";